import { render, staticRenderFns } from "./ImportCandidatesView.vue?vue&type=template&id=40031802&scoped=true"
import script from "./ImportCandidatesView.vue?vue&type=script&lang=ts"
export * from "./ImportCandidatesView.vue?vue&type=script&lang=ts"
import style0 from "./ImportCandidatesView.vue?vue&type=style&index=0&id=40031802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40031802",
  null
  
)

export default component.exports